import * as FARM_CONSTANTS from './constants'
import * as SCREEN_CONSTANTS from '../screen/constants'
import * as api from '../api/actions'

import { AVAILABLE_ENTITIES, Repository } from '../../database'

const startLoading = { type: SCREEN_CONSTANTS.START_LOADING }
const stopLoading = { type: SCREEN_CONSTANTS.END_LOADING }

export const listFarms = () => {
  return async (dispatch) => {
    dispatch(startLoading)

    const farms = await api.get(dispatch, 'farms', `Fazenda`)

    dispatch({
      type: FARM_CONSTANTS.LIST_FARMS,
      data: farms || [],
    })

    dispatch(stopLoading)
  }
}

export const getFarm = ({ id }) => {
  return async (dispatch) => {
    dispatch(startLoading)

    // const farm = await api.get(dispatch, 'farms', `Fazenda/${id}`);
    const repository = new Repository(AVAILABLE_ENTITIES.FARMS)
    const farm = (await repository.getById(id)).response
    dispatch({
      type: FARM_CONSTANTS.SELECT_FARM,
      data: farm,
    })

    dispatch(stopLoading)
  }
}

export const selectFarm = ({ farm }) => {
  return (dispatch) => {
    dispatch({
      type: FARM_CONSTANTS.SELECT_FARM,
      data: farm,
    })
  }
}

export const listBatches = ({ farmId = '' }) => {
  return async (dispatch) => {
    dispatch(startLoading)
    const lotes = await api.get(dispatch, 'batches', `Lote/fazenda/${farmId}`)
    dispatch({
      type: FARM_CONSTANTS.LIST_BATCHES,
      data: lotes,
    })
    dispatch(stopLoading)
  }
}

export const listTouros = ({ farmId }) => {
  return async (dispatch) => {
    dispatch(startLoading)

    const repository = new Repository(AVAILABLE_ENTITIES.BULLS)

    const touros = await repository.getByParam('farm_id', farmId)

    dispatch({
      type: FARM_CONSTANTS.LIST_TOUROS,
      data: touros.response,
    })
    dispatch(stopLoading)
  }
}

export const createTouro = (data) => {
  return async (dispatch) => {
    dispatch(startLoading)
    const repository = new Repository(AVAILABLE_ENTITIES.BULLS)
    const request = await repository.post(data)
    dispatch(stopLoading)

    return request.response
    // return await api.post(dispatch, `iatf`, 'Touro', data);
  }
}

export const listRacasMat = ({ racamatId }) => {
  return async (dispatch) => {
    dispatch(startLoading)

    const racasmat = await api.get(
      dispatch,
      'domains',
      `ValorDominio/tipoDominio/${racamatId}`,
    )

    dispatch({
      type: FARM_CONSTANTS.LIST_RACAS_MAT,
      data: racasmat || [],
    })

    dispatch(stopLoading)
  }
}

export const listOrdem = ({ ordemId }) => {
  return async (dispatch) => {
    dispatch(startLoading)

    const ordems = await api.get(
      dispatch,
      'domains',
      `ValorDominio/tipoDominio/${ordemId}`,
    )

    dispatch({
      type: FARM_CONSTANTS.LIST_ORDEM,
      data: ordems || [],
    })

    dispatch(stopLoading)
  }
}

export const listRacasBez = ({ racabezId }) => {
  return async (dispatch) => {
    dispatch(startLoading)

    const racasbez = await api.get(
      dispatch,
      'domains',
      `ValorDominio/tipoDominio/${racabezId}`,
    )

    dispatch({
      type: FARM_CONSTANTS.LIST_RACAS_BEZ,
      data: racasbez || [],
    })

    dispatch(stopLoading)
  }
}

export const listSexoBez = ({ sexobezId }) => {
  return async (dispatch) => {
    dispatch(startLoading)

    const sexobez = await api.get(
      dispatch,
      'domains',
      `ValorDominio/tipoDominio/${sexobezId}`,
    )

    dispatch({
      type: FARM_CONSTANTS.LIST_SEXO_BEZ,
      data: sexobez || [],
    })

    dispatch(stopLoading)
  }
}

export const listIdadeMat = ({ idadematId }) => {
  return async (dispatch) => {
    dispatch(startLoading)

    const idademat = await api.get(
      dispatch,
      'domains',
      `ValorDominio/tipoDominio/${idadematId}`,
    )

    dispatch({
      type: FARM_CONSTANTS.LIST_IDADE_MAT,
      data: idademat || [],
    })

    dispatch(stopLoading)
  }
}

export const listDispositivo = ({ deviceId }) => {
  return async (dispatch) => {
    dispatch(startLoading)

    const device = await api.get(
      dispatch,
      'domains',
      `ValorDominio/tipoDominio/${deviceId}`,
    )

    dispatch({
      type: FARM_CONSTANTS.LIST_DEVICE,
      data: device || [],
    })

    dispatch(stopLoading)
  }
}

export const selectBatch = ({ batch }) => {
  return (dispatch) => {
    dispatch({
      type: FARM_CONSTANTS.SELECT_BATCH,
      data: batch,
    })
  }
}

// TODO: Move to Protocol/actions
export const listProtocols = () => {
  return async (dispatch) => {
    dispatch(startLoading)

    const protocols = await api.get(dispatch, 'protocols', `Protocolo`)
    dispatch({
      type: FARM_CONSTANTS.LIST_PROTOCOLS,
      data: protocols,
    })

    dispatch(stopLoading)
  }
}
